const measurementIdSelector = 'meta[name="ga4-measurement-id"]'

export function trackPageView() {
  const measurementId = document.querySelector<HTMLMetaElement>(measurementIdSelector)?.content

  if (!measurementId || typeof window.gtag !== 'function') return

  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search,
  })
}
